import  React from 'react'
import { Alert } from 'react-bootstrap'
import * as H from 'history'

import { DocumentReformController } from '../../../controllers/DocumentReformController'
import { ISupportSpinner } from '../../../shared/Ajax'
import { ApplicationController } from '../../../controllers/ApplicationController'
import { GrantAgreementSummaryModel } from '../../../models/GrantAgreementSummaryModel'
import { Loading } from '../../../shared/fields'
import GrantAgreementHistoryTable from './GrantAgreementHistoryTable'
import EMDGAccordion from '../../../shared/EMDGAccordion'

interface Props {
  grantAgreementSummary: GrantAgreementSummaryModel
  history: H.History
  claimRandomIdentifier: string
}

export interface State {
  loading: boolean
  issueHistory: any
}

export default class GrantAgreement extends React.Component<Props, State> implements ISupportSpinner {
    docAjax: DocumentReformController
    ajax: ApplicationController

    constructor(props: Props) {
      super(props)
      this.docAjax = new DocumentReformController()
      this.ajax = new ApplicationController()

      this.state = {
        loading: false,
        issueHistory: null,
      }
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
      this.setState({ loading: on }, callback)
    }

    getGrantAgreement(): void {
      const { claimRandomIdentifier } = this.props
      if (!this.state.issueHistory) {
        this.ajax.getGrantAgreementHistory(this, claimRandomIdentifier, (issueHistory) => {
          this.setState({ issueHistory })
        })
      }
    }

    render() {
      const {
        loading, issueHistory,
      } = this.state
      const { grantAgreementSummary } = this.props

      const noBorder = { border: 'none' }

      return (
        <>
          <h3 className="mt-0">Grant Agreement</h3>

          <Alert className="emdg-page-alerts">
            The primary contact listed in your application must accept the grant agreement in the portal.
            Accepting the agreement is equivalent to signing a grant agreement.
            <br />
            <br />
            To discuss your agreement or request changes, please contact your Austrade grant assessor before accepting or declining the agreement.
            Alternatively, you can contact the EMDG helpline 13 28 78 or email
            {' '}
            <a href="mailto: EMDG.help@austrade.gov.au">EMDG.help@austrade.gov.au.</a>
          </Alert>
          <div style={{ maxWidth: '65%' }}>
            <div className="row mt-4 mb-2">
              <div className="col-md-2">
                <strong>Type of Grant</strong>
              </div>
              <div className="col-md-6">
                {grantAgreementSummary.grantType}
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-2">
                <strong>Duration</strong>
              </div>
              <div className="col-md-6">
                {grantAgreementSummary.startDate}
                {' '}
                to
                {' '}
                {grantAgreementSummary.endDate}
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-2">
                <strong>Status</strong>
              </div>
              <div className="col-md-6">
                {grantAgreementSummary.grantAgreementStatus}
              </div>
            </div>
          </div>

          <table className="table mt-4" style={{ maxWidth: '60%' }}>
            <thead>
              <tr>
                <th style={noBorder} scope="col">Issued Date</th>
                <th style={noBorder} scope="col">Due Date</th>
                <th style={noBorder} scope="col">Executed Date</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={noBorder}>{`${grantAgreementSummary.issuedDate} AEST`}</td>
                <td style={noBorder}>{grantAgreementSummary.dueDate}</td>
                <td style={noBorder}>{grantAgreementSummary.executedDate ? `${grantAgreementSummary.executedDate} AEST` : ''}</td>
              </tr>
            </tbody>
          </table>
          <EMDGAccordion expanded={false} header="Grant Agreement Issue History" onOpen={() => { this.getGrantAgreement() }}>
            { loading || !issueHistory ? <Loading /> : <GrantAgreementHistoryTable issueHistory={issueHistory} /> }
          </EMDGAccordion>
          <br />
        </>
      )
    }
}
